import { KeyScale } from '../axis/key/KeyScale.js';
import { KeyValueSet } from '../axis/key/KeyValueSet.js';
import { ValueScale } from '../axis/value/ValueScale.js';
import type { ColumnStackedRenderGroup, columnStackedRenderGroupData } from './types.js';
export const getX = (keyScale: KeyScale, group: ColumnStackedRenderGroup) => {
  const keyValue = group.isDualYTargetContext && group.yTarget === 'right' ? 1 : 0;
  return keyScale.start(keyValue);
};
export const getY = (valueScale: ValueScale, dp: columnStackedRenderGroupData) => {
  if (dp.value < 0) {
    return valueScale.clampPosition(dp.value) - getHeight(valueScale, dp);
  }
  return valueScale.clampPosition(dp.value);
};
export const getHeight = (valueScale: ValueScale, dp: columnStackedRenderGroupData) => {
  const prevY = valueScale.clampPosition(dp.previousValue);
  const currentY = valueScale.clampPosition(dp.value);
  return Math.abs(prevY - currentY);
};
export const createInnerKeyScale = (keyScale: KeyScale, group: ColumnStackedRenderGroup) => {
  const left = keyScale.start(group.key);
  const right = keyScale.end(group.key);
  const margin = keyScale.size * 0.2;
  const bounds = keyScale.bounds;
  bounds.left = left + margin;
  bounds.right = right - margin;
  const indices = group.isDualYTargetContext ? [0, 1] : [0];
  return new KeyScale(bounds, new KeyValueSet(indices));
};